import React from "react";
import { InputBaseProps } from "..";
import { SanityInputTextProps } from "../../../models/form/SanityFormInputField";
import { isNullOrWhiteSpace, isValidPostalCode } from "../../../shared/string";
import { CustomValidatorFunction } from "../Validation";
import GenericTextInput from "./GenericTextInput";
import { stripNonNumberOnChange } from "./NumberInput";

export type PostalCodeProps = InputBaseProps<SanityInputTextProps>;

const postalCodeValidator: CustomValidatorFunction = (value, translations) => {
  if (
    typeof value === "string" &&
    !isNullOrWhiteSpace(value) &&
    !isValidPostalCode(value.trim())
  ) {
    return translations.invalidPostalCode ?? "";
  }
};

const PostalCode = (props: PostalCodeProps) => (
  <GenericTextInput
    {...props}
    customValidator={postalCodeValidator}
    inputMode="numeric" // number keyboard on mobile, but still string input for validation
    onChange={stripNonNumberOnChange}
    type="text"
  />
);

export default PostalCode;
